<!-- @format -->

<template>
  <!-- <e-charts ref="line" autoresize :options="option" theme="theme-color" auto-resize /> -->
  <div style="width: auto;height: 300px" id="main"/>
</template>

<script>
import * as echarts from 'echarts'
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie'
import theme from './theme.json'

theme.color = [
  '#6610f2',
  '#28c76f',
]

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    series: {
      type: Array,
      default: null,
    },
    isJump: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      option: {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)',
        },
        color: ['#6610f2', '#28c76f'],
        legend: {
          x: 'center',
          bottom: '0',
        },
        series: this.series,
      },
    }
  },
  watch: {
    series: {
      handler() {
        this.initEcharts()
      },
      deep: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.initEcharts()
      })
    })
  },
  created() {
  },
  methods: {
    initEcharts() {
      const mychart = echarts.init(document.getElementById('main'))
      mychart.setOption(this.option)
      const that = this
      mychart.on('click', function (param) {
        if (param.data && param.data.name == 'Inforce TP' && that.isJump) {
          console.log(1)
        }
      })
      // 随着屏幕大小调节图表
      window.addEventListener('resize', () => {
        mychart.resize()
      })
    }
  }
}
</script>
